import { render, staticRenderFns } from "./OffersTab.vue?vue&type=template&id=725df208&scoped=true"
import script from "./OffersTab.vue?vue&type=script&lang=js"
export * from "./OffersTab.vue?vue&type=script&lang=js"
import style0 from "./OffersTab.vue?vue&type=style&index=0&id=725df208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725df208",
  null
  
)

export default component.exports